import { atom } from 'jotai';

export const ROUTE_REFERRER_SESSION_KEY = 'global_source_referrer';

const getInitialValue = (): string | null => {
	if (typeof window === 'undefined') return null;
	return sessionStorage.getItem(ROUTE_REFERRER_SESSION_KEY);
};

export const routeReferrerAtom = atom<string | null>(getInitialValue());